$.fn.tooltips = function(el) {
    // tooltip code. builds out functionality to work in $().tooltips()
    this.each(function(i, el) {
        let $el = $(el).attr("data-tooltip", i);
        let tip_div = $(`<div class="tooltip" data-tooltip="${i}" data-tooltip-style="right"></div>`);
        tip_div.html($el.attr("title"))
               .appendTo(document.body);

        $("<div class=\"arrow\"></div>").appendTo(tip_div);

        function position_tip () {
            let style = $el.data('tooltip-style') || 'right';
            tip_div.addClass(style);
            let link_position = $el.offset();
            let link_width = $el.width();

            if (style === 'right') {
                tip_div.css({
                    top: link_position.top - 39,
                    left: link_position.left + 20 + link_width
                });
            }
            if (style === 'below') {
                tip_div.css({
                    bottom: -(tip_div.height() + 23),
                    left: 0
                });
            }
        };

        position_tip();

        $el.removeAttr("title");

        $el.add(tip_div).hover(function(e) {
            position_tip();
            tip_div.addClass("active");
        }, function(e) {
            tip_div.removeClass("active");
        });
    });
};

export default $;



// WEBPACK FOOTER //
// ./assets/es6/common/tooltip.es6